export const ERROR_FETCHING_REVIEWS =
  'An error occurred while fetching the reviews, please try again later.'
export const REVIEWS_LIMIT = 10
